module.exports = __webpack_public_path__ + "img/dy01.d972723d.png";